import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "public.small" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M2 8.37417C2 7.91826 2.28708 7.51175 2.71674 7.35927L13.5629 3.51002C14.2639 3.26125 15 3.78111 15 4.52493V13.5297C15 14.2578 14.2924 14.7761 13.5982 14.5564L2.75203 11.1243C2.3043 10.9827 2 10.5672 2 10.0976V8.37417Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill_2",
    d: "M4.1998 10.6245L7.43235 10.0545L8.39824 15.5323C8.55563 16.425 7.9596 17.2762 7.06695 17.4336V17.4336C6.17431 17.591 5.32309 16.995 5.16569 16.1023L4.1998 10.6245Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill_3",
    d: "M16 6.17072V11.8293C17.1652 11.4175 18 10.3062 18 9.00001C18 7.69379 17.1652 6.58255 16 6.17072Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }